import React from 'react';

interface Props {
  namespace: string;
}

export default function RequestHandshakeSvg(props: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      viewBox='0 0 287.63 287.63'
    >
      <defs>
        <clipPath id={`${props.namespace}-a`} transform='translate(-68.86 -72.67)'>
          <rect x='100.13' y='103.93' width='225.1' height='225.1' style={{ fill: 'none' }} />
        </clipPath>
        <clipPath id={`${props.namespace}-b`}>
          <circle cx='143.82' cy='143.81' r='112.55' fill='none' />
        </clipPath>
        <clipPath id={`${props.namespace}-c`} transform='translate(-68.86 -72.67)'>
          <rect x='50.1' y='53.91' width='325.15' height='350.16' style={{ fill: 'none' }} />
        </clipPath>
        <clipPath id={`${props.namespace}-d`} transform='translate(-68.86 -72.67)'>
          <path
            d='M255.58,225.45A172.51,172.51,0,0,0,210,195.77a2.67,2.67,0,0,0-1.15,0,2.87,2.87,0,0,0-.82,0l-6.38,1.72a3.41,3.41,0,0,0-1.73,1.17l-4.12,5.78a10.09,10.09,0,0,1-5.64,3.43,4.88,4.88,0,0,1-4.53-1.38,5.33,5.33,0,0,1-1.36-4.9,20.12,20.12,0,0,1,6.09-10.51,27.6,27.6,0,0,1,7.45-4.81c13.42-6,27.69-2.05,36.21.29a39.22,39.22,0,0,0,6.46,1.46,12.47,12.47,0,0,0,8.23-2l17.37,31.06a23.93,23.93,0,0,1-10.58,8.37h0ZM255,235.87a8.74,8.74,0,0,1-6,2.72L224.76,223.1a2,2,0,0,0-2.84.63,2.08,2.08,0,0,0-.28,1.59,2,2,0,0,0,.94,1.3l23.7,15.15a9.57,9.57,0,0,1-1.93,3.26,6.66,6.66,0,0,1-4.81,2.13l-21.48-12.22a2.05,2.05,0,0,0-2.82.82,2.13,2.13,0,0,0,.8,2.87l20.58,11.68a6.91,6.91,0,0,1-2.72,4.19,7.42,7.42,0,0,1-6,1H227.6a3,3,0,0,0-.41-0.33l-16.46-8.37a2,2,0,0,0-2.63,1,2.11,2.11,0,0,0,.78,2.74l15.76,8.08a7.92,7.92,0,0,1-4.12,3.14,23.73,23.73,0,0,1-16.46-3l1.32-2.05a8.48,8.48,0,0,0,1.4-6.19,8.28,8.28,0,0,0-7.65-6.86,8.85,8.85,0,0,0,.25-3.89,8.39,8.39,0,0,0-3.29-5.36,8.13,8.13,0,0,0-5.1-1.55,8,8,0,0,0,0-2.43,8.31,8.31,0,0,0-6.24-6.6,8.16,8.16,0,0,0-8.45,3.16l-0.37.5a7.59,7.59,0,0,0-2.63-3.22,8.14,8.14,0,0,0-11.36,1.93l-0.33.42a99,99,0,0,1-8.23-9.79l17.94-32.06a23.55,23.55,0,0,0,9.38,5.82l4.12,0.59a24.71,24.71,0,0,0-4.44,9.54,9.4,9.4,0,0,0,2.43,8.75A8.87,8.87,0,0,0,191,212a13.83,13.83,0,0,0,8-4.9l4.12-5.57,5.8-1.55a172.54,172.54,0,0,1,44.48,29.3h0.25a2,2,0,0,0,.41.38,4.19,4.19,0,0,1,1.6,2.59A4.8,4.8,0,0,1,255,235.87ZM202,254.29l-2.59,3.64-0.33.5-1,1.42a4.06,4.06,0,0,1-5.06.67,4.22,4.22,0,0,1-1.81-4.86l0.33-.54,3.91-5.57a4.07,4.07,0,0,1,5.56-.88,4.23,4.23,0,0,1,.95,5.73Zm-13.83-1.63-1,1.38a4.09,4.09,0,0,1-7.65-.31,4.23,4.23,0,0,1,1.18-4.55l7.37-10.55a4.07,4.07,0,0,1,4.13-1.29,4.16,4.16,0,0,1,3,3.18,3.86,3.86,0,0,1-.7,3.06L192,247.13Zm-10.9-5.78-0.53.75a4.09,4.09,0,0,1-7.63-.22,4.23,4.23,0,0,1,1.08-4.55l1.48-2.05L175,236l4.44-6.36a4.12,4.12,0,0,1,2.56-1.89,4.06,4.06,0,0,1,3.12.51,3.94,3.94,0,0,1,1.65,2.68,4.24,4.24,0,0,1-.7,3.06l-1.48,2.13Zm-8.89-8.66a4.07,4.07,0,0,1-5.56.92,4.23,4.23,0,0,1-.95-5.69l1.48-2.18,1.89-2.68a4.07,4.07,0,0,1,5.64-1,4.23,4.23,0,0,1,1.28,5.19Zm76.91-65.5a3.29,3.29,0,0,0-1.19,4.44l2.47,5.06a8.49,8.49,0,0,1-6,1.46,37.76,37.76,0,0,1-5.76-1.34c-9.05-2.47-24.16-6.65-39,0a28.73,28.73,0,0,0-7.78,4.9c-1.36,0-4.12-.5-7-0.92a22.77,22.77,0,0,1-7.78-5.27l1.73-3.1a3.29,3.29,0,0,0-1.19-4.44l-30,53.78a3,3,0,0,0,4.36-1.09l2.92-5.19a95.2,95.2,0,0,0,7.86,9.25l-0.66,1a8.43,8.43,0,0,0,1.93,11.55,7.69,7.69,0,0,0,4.69,1.55c0.21,0.83.21,1.68,0.33,2.51a8.39,8.39,0,0,0,3.33,5.36,7.81,7.81,0,0,0,4.69,1.55,8.1,8.1,0,0,0,2.47-.38,8.36,8.36,0,0,0,4.05,5.69,8.11,8.11,0,0,0,6.89.54,8.38,8.38,0,0,0,3.21,4.81,7.81,7.81,0,0,0,4.69,1.51h1.4a8,8,0,0,0,5.27-3.35,39.55,39.55,0,0,0,15.1,3.93,15.89,15.89,0,0,0,5.39-1,11.81,11.81,0,0,0,6.87-5.69h1.36a11.18,11.18,0,0,0,6.46-2,11.31,11.31,0,0,0,4.36-6.65,10.35,10.35,0,0,0,6.67-3.47,14.21,14.21,0,0,0,2.84-5.11,11.88,11.88,0,0,0,8.23-4.48,9,9,0,0,0,1.19-6.82,9.13,9.13,0,0,0-1.07-2.72,28.26,28.26,0,0,0,9.71-7.7l2.39,4.19a3.26,3.26,0,0,0,1.93,1.55,3.08,3.08,0,0,0,.86,0,3.49,3.49,0,0,0,1.56-.42Z'
            style={{ fill: 'none' }}
          />
        </clipPath>
      </defs>
      <title>Handshake</title>
      <g style={{ clipPath: `url(#${props.namespace}-a)` }}>
        <g style={{ clipPath: `url(#${props.namespace}-b)` }}>
          <g style={{ clipPath: `url(#${props.namespace}-c)` }}>
            <rect className='handshake-background' width='287.63' height='287.63' fill='#677178' />
            <circle
              className='handshake-border'
              cx='143.82'
              cy='143.81'
              r='112.55'
              fill='none'
              strokeWidth='10'
            />
          </g>
        </g>

        <g style={{ clipPath: `url(#${props.namespace}-d)` }}>
          <g style={{ clipPath: `url(#${props.namespace}-c)` }}>
            <rect
              className='handshake-hands'
              x='43.77'
              y='68.78'
              width='193.84'
              height='156.32'
              fill='#fff'
            />
          </g>
        </g>

        <g className='handshake-horns' stroke='#fff'>
          <line
            x1='117.88'
            y1='75.26'
            x2='125.51'
            y2='89.95'
            style={{ strokeMiterlimit: 10, strokeWidth: '4px' }}
          />
          <line
            x1='163.02'
            y1='75.26'
            x2='155.4'
            y2='89.95'
            style={{ strokeMiterlimit: 10, strokeWidth: '4px' }}
          />
          <line
            x1='140.26'
            y1='69.95'
            x2='140.48'
            y2='86.49'
            style={{ strokeMiterlimit: 10, strokeWidth: '4px' }}
          />
        </g>
      </g>
    </svg>
  );
}
